"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var FieldPaths = {
  EVENT_TIME: 'event.date',
  RECEIVED_TIME: 'metadata.receiveddate',
  TASK_STATUS: 'task.statusCode'
};
var _default = FieldPaths;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(FieldPaths, "FieldPaths", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/field-paths.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/field-paths.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJGaWVsZFBhdGhzIiwiRVZFTlRfVElNRSIsIlJFQ0VJVkVEX1RJTUUiLCJUQVNLX1NUQVRVUyJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tb24vZmllbGQtcGF0aHMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgRmllbGRQYXRocyA9IHtcblx0RVZFTlRfVElNRTogJ2V2ZW50LmRhdGUnLFxuXHRSRUNFSVZFRF9USU1FOiAnbWV0YWRhdGEucmVjZWl2ZWRkYXRlJyxcblx0VEFTS19TVEFUVVM6ICd0YXNrLnN0YXR1c0NvZGUnLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRmllbGRQYXRocztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBLElBQU1BLFVBQVUsR0FBRztFQUNsQkMsVUFBVSxFQUFFLFlBQVk7RUFDeEJDLGFBQWEsRUFBRSx1QkFBdUI7RUFDdENDLFdBQVcsRUFBRTtBQUNkLENBQUM7QUFBQyxlQUVhSCxVQUFVO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBLHdCQU5uQkEsVUFBVTtFQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtBQUFBIn0=